import { atom } from "recoil";

const mealsCategoriesFilterAtom = atom({
  key: "mealsCategoriesFilter",
  default: {
    mealIndex: "meal_1",
    mealIndexLabel: "Breakfast",
  },
});

export default mealsCategoriesFilterAtom;
